import {
    OPTION_ALERT_LIST_ATTEMPT,
    OPTION_ALERT_LIST_SUCCESS,
    OPTION_ALERT_LIST_FAILED,
    OPTION_ALERT_NEW_SUCCESS,
    OPTION_ALERT_NEW_FAILED,
    OPTION_ALERT_REMOVE_SUCCESS,
    OPTION_ALERT_REMOVE_FAILED,
} from '../types/optionAlertTypes';
import { LOGOUT } from '../types/sessionTypes';

const INITIAL_STATE = {
    loading: false,
    list: [],
    error: '',
};

function optionAlert(state = INITIAL_STATE, action) {
    switch (action.type) {
        case OPTION_ALERT_LIST_ATTEMPT:
            return { ...state, loading: true };
        case OPTION_ALERT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.data.list,
                error: '',
            };
        case OPTION_ALERT_LIST_FAILED:
            return { ...state, loading: false, error: action.error };
        case OPTION_ALERT_NEW_SUCCESS:
            return {
                ...state,
                list: [action.item, ...state.list.filter((row) => row.id !== action.item.id)],
                error: '',
            };
        case OPTION_ALERT_NEW_FAILED:
            return { ...state, error: action.error };
        case OPTION_ALERT_REMOVE_SUCCESS: {
            const list = state.list.filter((row) => String(row.id) !== String(action.item.id));
            return { ...state, list, error: '' };
        }
        case OPTION_ALERT_REMOVE_FAILED:
            return { ...state, error: action.error };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default optionAlert;
